// Libraries the app code (and jQuery UI loaded from CDN on admin pages) expects as globals.
// Kept in its own module so the assignments run before angular and the jQuery plugins load.
import jQuery from "jquery"
import _ from "underscore"

window.$ = window.jQuery = jQuery
window._ = _
